
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TestCreatorHeaderProps {
  isEditing: boolean;
  onBackClick?: () => void;
}

export const TestCreatorHeader = ({
  isEditing,
  onBackClick
}: TestCreatorHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleBack = () => {
    if (onBackClick) {
      // Use the custom back handler if provided
      onBackClick();
    } else {
      // Default behavior - go back in browser history
      navigate(-1);
    }
  };
  
  return (
    <div className="flex items-center space-x-4 mb-6">
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={handleBack} 
        className="text-foreground hover:bg-accent"
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <h1 className="text-xl font-semibold text-foreground">
        {isEditing ? "Edit Test" : "Create Test"}
      </h1>
    </div>
  );
};
